import { Injectable } from '@angular/core';

@Injectable()
export class AppConstant
{
    readonly LOCATE_NOW: string = 'Locate Now';
    readonly IGNITION_ON: string = 'Ignition On';
    readonly IGNITION_OFF: string = 'Ignition Off';
    readonly QUERY: string = 'Query';
    readonly REQUEST: string = 'Request';
    readonly RESPONSE: string = 'Response';
    readonly BOTH: string = 'Both';
}



// WEBPACK FOOTER //
// ./src/app/service/app.constant.ts